import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ERFormComponent } from '../../components/index';

export interface DeactivationGuard {
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
    providedIn: 'root'
})
export class ERFormCDGuard implements CanDeactivate<ERFormComponent> {
    canDeactivate(component: ERFormComponent): Observable<boolean> | Promise<boolean> | boolean {

      return component.canDeactivate ? component.canDeactivate() : true;
    }
}
